import { render } from "./Home.vue?vue&type=template&id=091f16c8&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=091f16c8&lang=less&scoped=true"

import exportComponent from "/root/workspace/school-mobile_yvTP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091f16c8"]])

export default __exports__